import React, { useState, useEffect } from 'react';
import './WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const phoneNumber = '905327907812';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-fab"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <div className={`whatsapp-bubble ${isMounted ? 'show-initial' : ''}`}>
        Bize Whatsapp'tan ulaşabilirsiniz!
      </div>
      <img 
        src={`${process.env.PUBLIC_URL}/images/whatsapp-icon.png`}
        alt="WhatsApp"
        className="whatsapp-icon"
      />
    </a>
  );
};

export default WhatsAppButton;
